import type { RouteRecordRaw } from 'vue-router'

const deviceSimulatorRoutes: RouteRecordRaw[] = [
  {
    path: 'device-simulator',
    name: 'device-simulator',
    meta: {
      titleKey: 'routes.device-simulator.title',
      icon: 'Monitor',
      helpKey: 'device_simulator'
    },
    redirect: { name: 'simulator-devices' },
    children: [
      {
        path: 'devices',
        name: 'simulator-devices',
        component: () => import('@/views/device-simulator/SimulatorDevices.vue'),
        meta: { titleKey: 'routes.device-simulator.devices.title', helpKey: 'simulator_devices' }
      },
      {
        path: 'v2',
        name: 'simulator-v2',
        component: () => import('@/views/device-simulator-v2/SimulatorStage.vue'),
        meta: { titleKey: 'routes.device-simulator.v2.title', helpKey: 'simulator_v2' }
      },
      {
        path: 'data-generator',
        name: 'simulator-data-generator',
        component: () => import('@/views/device-simulator/DataGenerator.vue'),
        meta: { titleKey: 'routes.device-simulator.data-generator.title', helpKey: 'simulator_data_generator' }
      }
    ]
  }
]

export default deviceSimulatorRoutes
